export default __webpack_public_path__ + "static/media/1c49f19fbcd50a557d8e057f54606f4e1602952547779.1fbefda2.webp";